@if (meetingTypes?.length > 1) {
  <div 
    class="cw-meeting-providers"  
    role="region" 
    aria-label="Meeting Type Selection"
  >
    <h4 class="cw-meeting-provider-title">
      {{ (widgetTemplates | calioMeetingTemplate: { id: templateConstant.WIDGET_MEETING_TYPES_LABEL, type: 'template' }) | translation: templateContent.TEMPLATE_CONTENT: lang }}
    </h4>
    <div class="custom-field form-group meeting-providers-padding">
      <label for="meeting_type_id" class="cw-meeting-input-label" id="label_meeting_type_id">
        <span [innerHTML]="((widgetTemplates | calioMeetingTemplate: { id: templateConstant.WIDGET_WHERE_SHOULD_THE_MEETING_TAKE_PLACE, type: 'template' }) | translation: templateContent.TEMPLATE_CONTENT: lang) | trustHtml"></span>
        <span aria-hidden="true">*</span>
      </label>

      @if (showMeetingTypesAsTiles()) {
        <div class="row cbw-meeting-type-card-container" id="meeting-type-options">
          @for (meetingType of meetingTypes; track meetingType.id) {
            <div class="col-md-6 mt-3">
              <!-- role="button" + aria-pressed (not listbox/option): a listbox promises arrow-key
                   navigation we do not implement. Matches the smart widget's meeting-type card. -->
              <div
                class="cbw-meeting-type-card d-flex align-items-center justify-content-between"
                role="button"
                tabindex="0"
                [class.cbw-active-meeting-type-card]="meetingType.id === appointmentState.meeting_type_id"
                [attr.aria-pressed]="meetingType.id === appointmentState.meeting_type_id"
                (click)="onMeetingTypeChange(meetingType)"
                (keydown.enter)="onMeetingTypeChange(meetingType)"
                (keydown.space)="onMeetingTypeChange(meetingType); $event.preventDefault();"
              >
                <div class="d-flex align-items-center">
                  <ng-container *ngTemplateOutlet="meetingTypeList; context: { meetingType: meetingType }" />

                  @if ((widgetTemplates | calioMeetingTemplate: { id: meetingType.id, type: 'meeting_template' }); as widgetTemplate) {
                    <div class="meeting-option">
                      @if ((widgetTemplate.titleTemplate | translation: templateContent.TEMPLATE_CONTENT: lang)) {
                        <div
                          class="meeting-type-name cbw-meeting-type-title"
                          [innerHTML]="(widgetTemplate.titleTemplate | translation: templateContent.TEMPLATE_CONTENT: lang) | trustHtml"
                        ></div>
                      }
                      @if ((widgetTemplate.descTemplate | translation: templateContent.TEMPLATE_CONTENT: lang)) {
                        <div
                          class="cbw-meeting-type-description"
                          [innerHTML]="(widgetTemplate.descTemplate | translation: templateContent.TEMPLATE_CONTENT: lang) | trustHtml"
                        ></div>
                      }
                    </div>
                  }
                </div>

                <!-- Same tick the resource step uses. Decorative only: aria-pressed on the card
                     already conveys selection, so the icon is hidden from assistive tech. -->
                <app-cw-radio-tick-button
                  class="cbw-meeting-type-tick"
                  [checked]="meetingType.id === appointmentState.meeting_type_id"
                  [color]="meetingType.id === appointmentState.meeting_type_id ? widgetColorConf?.widget_header_active_color : ''"
                  [attr.aria-hidden]="true"
                />
              </div>
            </div>
          }
        </div>
      } @else {
      <ng-select
        id="meeting_type_id"
        name="meeting_type_id"
        #meeting_type_id="ngModel"
        [(ngModel)]="appointmentState.meeting_type_id"
        [items]="meetingTypes"
        [clearable]="false"
        [bindValue]="'id'"
        [required]="true"
        [searchable]="false"
        (change)="onMeetingTypeChange($event)"
        class="cbw-meeting-type"
        labelForId="label_meeting_type_id"
        aria-describedby="meeting-provider-heading"
        aria-labelledby="label_meeting_type_id"
        role="combobox"
        [attr.aria-expanded]="false"
        [attr.aria-controls]="'meeting-type-options'"
      >
        <ng-template ng-option-tmp let-meetingType="item">
          <div 
            class="d-flex align-items-center" 
            role="option" 
            [attr.aria-selected]="meetingType.id === appointmentState.meeting_type_id"
          >
            <ng-container *ngTemplateOutlet="meetingTypeList; context: { meetingType: meetingType }" />

            @if ((widgetTemplates | calioMeetingTemplate: { id: meetingType.id, type: 'meeting_template' }); as widgetTemplate) {
              <div class="meeting-option">
                @if ((widgetTemplate.titleTemplate | translation: templateContent.TEMPLATE_CONTENT: lang)) {
                  <div
                    class="meeting-type-name"
                    [innerHTML]="(widgetTemplate.titleTemplate | translation: templateContent.TEMPLATE_CONTENT: lang) | trustHtml"
                    aria-live="polite"
                  >
                  </div>
                }
                @if ((widgetTemplate.descTemplate | translation: templateContent.TEMPLATE_CONTENT: lang)) {
                  <div
                    [innerHTML]="(widgetTemplate.descTemplate | translation: templateContent.TEMPLATE_CONTENT: lang) | trustHtml"
                    aria-live="polite"
                  >
                  </div>
                }
                @if (meetingType.id === 1 && selectedStore) {
                  <div class="cbw-summary-worker-store-location" aria-live="polite">
                    <span class="cbw-summary-worker-store-location-name">{{ selectedStore | translation: 'name' : lang }}</span>
                    @if (selectedStore.is_online === 0) {
                      <span class="cbw-summary-worker-store-location-separator" aria-hidden="true">,</span>
                      <span class="cbw-summary-worker-store-location-address whitespace-pre-line">
                        @let addressInput = {
                          street: selectedStore.street,
                          zip: selectedStore.zip,
                          city: selectedStore.city,
                          country: selectedStore.country | translation: 'name' : lang,
                          country_code: selectedStore.country?.identifier
                        };
                        {{ addressInput | addressFormat: 'single' }}
                      </span>
                    }
                  </div>
                }
              </div>
            }
          </div>
        </ng-template>

        <ng-template ng-label-tmp let-meetingType="item">
          <div class="d-flex align-items-center">
            <ng-container *ngTemplateOutlet="meetingTypeList; context: { meetingType: meetingType }" />

            @if ((widgetTemplates | calioMeetingTemplate: { id: meetingType.id, type: 'meeting_template' }); as widgetTemplate) {
              <div class="meeting-option">
                @if ((widgetTemplate.titleTemplate | translation: templateContent.TEMPLATE_CONTENT: lang)) {
                  <div class="meeting-type-name"
                    [innerHTML]="(widgetTemplate.titleTemplate | translation: templateContent.TEMPLATE_CONTENT: lang) | trustHtml"
                    aria-live="polite"
                  >
                  </div>
                }
                @if ((widgetTemplate.descTemplate | translation: templateContent.TEMPLATE_CONTENT: lang)) {
                  <div 
                    [innerHTML]="(widgetTemplate.descTemplate | translation: templateContent.TEMPLATE_CONTENT: lang) | trustHtml"
                    aria-live="polite"
                  >
                  </div>
                }
              </div>
            }
          </div>
        </ng-template>
      </ng-select>
      }
    </div>
  </div>
} @else if (isMeetingTypesLoading && showMeetingTypesAsTiles()) {
  <div
    class="cw-meeting-providers"
    role="status"
    aria-live="polite"
    [attr.aria-label]="'common.loading' | translate"
  >
    <div class="custom-field form-group meeting-providers-padding">
      <div class="row cbw-meeting-type-card-container">
        @for (ghostTile of ghostTiles; track ghostTile) {
          <div class="col-md-6 mt-3">
            <div class="cbw-meeting-type-card cbw-meeting-type-card-ghost d-flex align-items-center">
              <div class="skeleton-animation d-flex align-items-center w-100">
                <div class="bar cbw-meeting-type-ghost-icon"></div>
                <div class="w-100 ps-2">
                  <div class="bar cbw-meeting-type-ghost-title"></div>
                  <div class="bar cbw-meeting-type-ghost-description mt-2"></div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
}

@if (showStepValidationError() && appointmentState?.has_meeting_types_restrictions && !appointmentState?.meeting_type_id) {
  <div
    id="cbw-meeting-type-validation-error"
    class="cbw-global-step-error cbw-meeting-type-step-error"
    role="alert"
    aria-live="assertive"
    aria-atomic="true"
  >
    <div class="cbw-step-error-text">
      {{ stepErrorTemplate ? (stepErrorTemplate | translation: templateContent.TEMPLATE_CONTENT: lang) : ('alert_messages.next_step_error_meeting_type' | translate) }}
    </div>
  </div>
}

<div
  class="wizard-footer clearfix"
  role="navigation"
  aria-label="Navigation Buttons"
>
  <div class="row margin-x-0">
    <div class="col-4 d-flex align-items-center justify-content-start">
      @if (!isWhitelabel()) {
        <div class="d-md-none">
          <img
            alt="Logo"
            src="{{ environment.deployUrl }}/assets/images/{{ environment.footerLogoUrl }}"
            width="100"
            aria-hidden="true"
          >
        </div>
      }
    </div>
    <div class="col-4 d-flex align-items-center justify-content-center">
      @if (!isWhitelabel()) {
        <div class="d-none d-md-block">
          <img
            alt="Logo"
            src="{{ environment.deployUrl }}/assets/images/{{ environment.footerLogoUrl }}"
            width="100"
            aria-hidden="true"
          >
        </div>
      }
    </div>
    <div class="col-4 d-flex align-items-center justify-content-end next-btn-custom-right-padding">
      <calenso-button
        type="secondary"
        id="cbw-prev-button"
        class="me-2"
        text="{{ previousButtonTemplate | translation: templateContent.TEMPLATE_CONTENT: lang }}"
        placement="left"
        [widgetColorConf]="widgetColorConf"
        (clickEvent)="navigateTo(appointmentConstant.WORKER)"
        [attr.aria-label]="previousButtonTemplate | translation: templateContent.TEMPLATE_CONTENT: lang"
      />

      <calenso-button
        type="primary"
        id="cbw-next-button"
        text="{{ nextButtonTemplate | translation: templateContent.TEMPLATE_CONTENT: lang }}"
        placement="right"
        [disabled]="+partner?.widget_buttons_always_enabled === 1 ? false : (appointmentState?.has_meeting_types_restrictions && !appointmentState?.meeting_type_id)"
        [widgetColorConf]="widgetColorConf"
        (clickEvent)="onNextButtonClick()"
        [attr.aria-label]="nextButtonTemplate | translation: templateContent.TEMPLATE_CONTENT: lang"
        [attr.aria-disabled]="+partner?.widget_buttons_always_enabled === 1 ? false : (appointmentState?.has_meeting_types_restrictions && !appointmentState?.meeting_type_id)"
        [attr.aria-describedby]="showStepValidationError() && appointmentState?.has_meeting_types_restrictions && !appointmentState?.meeting_type_id ? 'cbw-meeting-type-validation-error' : null"
      />
    </div>
  </div>
</div>

<ng-template #meetingTypeList let-meetingType="meetingType">
  <div class="meeting-icon d-flex align-items-center" aria-hidden="true">
    @if (meetingType.id === 1) {
      <img class="meeting_type_id_1" src="{{ environment.baseUrl }}/images/meetings/store.svg" alt="Store Logo" width="26px" />
    } @else if (meetingType.id === 2) {
      <img class="meeting_type_id_2" src="{{ environment.baseUrl }}/images/meetings/zoom.svg" alt="Zoom Logo" width="26px" />
    } @else if (meetingType.id === 4) {
      <img class="meeting_type_id_4" src="{{ environment.baseUrl }}/images/meetings/phone.svg" alt="Phone Logo" width="26px" height="30px" />
    } @else if (meetingType.id === 5) {
      <img class="meeting_type_id_5" src="{{ environment.baseUrl }}/images/meetings/customer.svg" alt="Customer Logo" width="26px" />
    } @else if (meetingType.id === 6) {
      <img class="meeting_type_id_6" src="{{ environment.baseUrl }}/images/meetings/unblu.svg" alt="Unblu Logo" width="26px" />
    } @else if (meetingType.id === 7) {
      <img class="meeting_type_id_7" src="{{ environment.baseUrl }}/images/meetings/teams.svg" alt="Teams Logo" width="26px" />
    } @else if (meetingType.id === 8) {
      <img class="meeting_type_id_8" src="{{ environment.baseUrl }}/images/meetings/meet.svg" alt="Meet Logo" width="26px" />
    } @else if (meetingType.id === 9) {
      <img class="meeting_type_id_9" src="{{ environment.baseUrl }}/images/meetings/gotomeeting.png" alt="Gotomeeting Logo" width="26px" />
    } @else if (meetingType.id === 10) {
      <img class="meeting_type_id_10" src="{{ environment.baseUrl }}/images/meetings/webex.png" alt="Webex Logo" width="26px" />
    } @else if (meetingType.id === 11) {
      <img class="meeting_type_id_11" src="{{ environment.baseUrl }}/images/meetings/phone.svg" alt="Phone Logo" width="26px" height="30px" />
    } @else if (meetingType.id === 13) {
      <img class="meeting_type_id_13" src="{{ environment.baseUrl }}/images/meetings/metaverse.svg" alt="Metaverse" width="26px" />
    } @else if (meetingType.id === 14) {
      <img class="meeting_type_id_14" src="{{ environment.baseUrl }}/images/meetings/store.svg" alt="Appointment Location" width="26px" />
    } @else if (meetingType.id === 15) {
      <img class="meeting_type_id_15" src="{{ environment.baseUrl }}/images/meetings/kmeet.png" alt="kMeet" width="26px" />
    }
  </div>
</ng-template>
